export const normalizeTriggerScreenName = (name: string): string =>
  name.trim().toUpperCase().replace(/\s+/g, "_");

export const screenMatchesAnyTrigger = (
  currentMainStepName: string | undefined,
  triggerScreens: string[] | undefined,
  currentSubStepName?: string | undefined
): boolean => {
  if (!triggerScreens?.length) {
    return false;
  }
  const normalizedTriggers = triggerScreens
    .filter(Boolean)
    .map((t) => normalizeTriggerScreenName(t));
  const main = currentMainStepName
    ? normalizeTriggerScreenName(currentMainStepName)
    : "";
  const sub = currentSubStepName
    ? normalizeTriggerScreenName(currentSubStepName)
    : "";
  return normalizedTriggers.some(
    (t) => t === main || (sub.length > 0 && t === sub)
  );
};
